import { ARTBEY_MATRICES } from "./artbeyMatrices";

/**
 * Artbey 2026 Zip Perde Fiyat Listesi — Matris Verileri
 * Kaynak: ARTBEY 2026 Zip Perde Fiyat Listesi Master Sürüm.pdf
 * 
 * Her model için: widths (cm), heights (cm), prices (EUR, adettir m² değil)
 * Kırmızı alan = garanti kapsamı dışı
 */

// ─── SKY 1300 ──────────────────────────────────────────────────────────────
// Max: 4m genişlik × 4.5m yükseklik, 25cm adım
export const SKY1300 = {
  widths:  [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400],
  heights: [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450],
  prices: [
    // w→  100   125   150   175   200   225   250   275   300   325   350   375   400
    [731,  769,  807,  845,  883,  921,  959,  997, 1035, 1073, 1111, 1149, 1187], // h=100
    [763,  802,  842,  881,  920,  960,  999, 1039, 1078, 1117, 1157, 1196, 1236], // h=125
    [794,  835,  876,  917,  958,  999, 1039, 1080, 1121, 1162, 1203, 1244, 1285], // h=150
    [826,  868,  911,  953,  995, 1037, 1080, 1122, 1164, 1207, 1249, 1291, 1333], // h=175
    [858,  902,  945,  989, 1033, 1076, 1120, 1164, 1207, 1251, 1295, 1338, 1382], // h=200
    [890,  935,  980, 1025, 1070, 1115, 1160, 1205, 1250, 1296, 1341, 1386, 1431], // h=225
    [921,  968, 1014, 1061, 1107, 1154, 1201, 1247, 1294, 1340, 1387, 1433, 1480], // h=250
    [953, 1001, 1049, 1097, 1145, 1193, 1241, 1289, 1337, 1385, 1433, 1481, 1529], // h=275
    [985, 1034, 1084, 1133, 1182, 1232, 1281, 1330, 1380, 1429, 1479, 1528, 1577], // h=300
    [1017, 1067, 1118, 1169, 1220, 1271, 1321, 1372, 1423, 1474, 1525, 1575, 1626], // h=325
    [1048, 1101, 1153, 1205, 1257, 1309, 1362, 1414, 1466, 1518, 1570, 1623, 1675], // h=350
    [1080, 1134, 1187, 1241, 1295, 1348, 1402, 1456, 1510, 1563, 1616, 1670, 1724], // h=375
    [1112, 1167, 1222, 1277, 1332, 1387, 1442, 1497, 1552, 1607, 1662, 1717, 1773], // h=400
    [1144, 1200, 1257, 1313, 1369, 1426, 1482, 1539, 1595, 1652, 1708, 1765, 1821], // h=425
    [1175, 1233, 1291, 1349, 1407, 1465, 1523, 1581, 1639, 1696, 1754, 1812, 1870], // h=450
  ],
  // Sky 1300 için garanti kapsamı dışı bölge yok
  isRedZone: (_w, _h) => false,
};

// ─── SKY 1400 ──────────────────────────────────────────────────────────────
// Max: 6m × 6m; Heights 1.75m eksik (1.5'ten sonra 2'ye atlar)
// Garanti kapsamı dışı: H ≥ 525cm VE W ≥ 475cm
export const SKY1400 = {
  widths:  [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
  heights: [100, 125, 150, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
  prices: [
    // w→  100   125   150   175   200   225   250   275   300   325   350   375   400   425   450   475   500   525   550   575   600
    [ 835,  882,  929,  976, 1022, 1069, 1116, 1163, 1210, 1256, 1303, 1350, 1397, 1443, 1490, 1537, 1584, 1630, 1677, 1724, 1771], // h=100
    [ 870,  918,  967, 1015, 1063, 1111, 1159, 1206, 1254, 1301, 1352, 1400, 1448, 1497, 1545, 1593, 1641, 1689, 1737, 1786, 1834], // h=125
    [ 905,  955, 1004, 1054, 1103, 1153, 1202, 1252, 1301, 1351, 1401, 1451, 1500, 1550, 1599, 1649, 1698, 1748, 1797, 1847, 1897], // h=150
    [ 940,  991, 1042, 1093, 1144, 1195, 1246, 1297, 1348, 1399, 1450, 1501, 1551, 1603, 1654, 1705, 1756, 1807, 1858, 1909, 1960], // h=200
    [ 975, 1027, 1079, 1132, 1184, 1237, 1289, 1342, 1394, 1447, 1499, 1551, 1604, 1656, 1709, 1761, 1814, 1866, 1919, 1971, 2023], // h=225
    [1009, 1063, 1117, 1171, 1225, 1279, 1332, 1386, 1440, 1494, 1548, 1597, 1652, 1707, 1763, 1816, 1873, 1929, 1984, 2039, 2095], // h=250
    [1044, 1099, 1155, 1210, 1265, 1320, 1376, 1431, 1486, 1536, 1597, 1646, 1703, 1753, 1811, 1869, 1927, 1986, 2043, 2100, 2156], // h=275
    [1079, 1136, 1192, 1249, 1306, 1362, 1419, 1476, 1532, 1589, 1646, 1695, 1753, 1811, 1869, 1927, 1986, 2042, 2101, 2161, 2218], // h=300
    [1114, 1172, 1230, 1288, 1346, 1404, 1462, 1520, 1579, 1637, 1695, 1753, 1811, 1869, 1927, 1986, 2042, 2098, 2157, 2215, 2276], // h=325
    [1148, 1208, 1267, 1327, 1387, 1446, 1506, 1565, 1625, 1684, 1744, 1793, 1863, 1923, 1982, 2042, 2101, 2159, 2220, 2280, 2339], // h=350
    [1183, 1244, 1305, 1366, 1427, 1488, 1549, 1610, 1671, 1732, 1793, 1854, 1915, 1976, 2037, 2098, 2159, 2220, 2281, 2341, 2403], // h=375
    [1218, 1280, 1343, 1405, 1467, 1530, 1592, 1655, 1717, 1779, 1842, 1904, 1967, 2029, 2091, 2154, 2216, 2279, 2341, 2403, 2465], // h=400
    [1253, 1316, 1380, 1444, 1508, 1572, 1636, 1699, 1763, 1827, 1891, 1955, 2018, 2082, 2146, 2210, 2274, 2338, 2396, 2462, 2527], // h=425
    [1287, 1353, 1418, 1483, 1548, 1614, 1679, 1744, 1809, 1875, 1940, 2005, 2070, 2136, 2201, 2266, 2331, 2396, 2462, 2527, 2592], // h=450
    [1322, 1389, 1455, 1522, 1589, 1655, 1722, 1789, 1855, 1922, 1989, 2055, 2122, 2189, 2255, 2322, 2389, 2455, 2522, 2589, 2655], // h=475
    [1357, 1425, 1493, 1561, 1629, 1697, 1765, 1834, 1902, 1970, 2038, 2106, 2174, 2242, 2310, 2378, 2446, 2514, 2582, 2651, 2719], // h=500
    [1392, 1461, 1531, 1600, 1670, 1739, 1809, 1878, 1948, 2017, 2087, 2156, 2226, 2295, 2365, 2434, 2504, 2573, 2643, 2712, 2782], // h=525 ← kırmızı başlangıcı
    [1426, 1497, 1568, 1639, 1710, 1781, 1852, 1923, 1994, 2065, 2136, 2207, 2278, 2349, 2419, 2490, 2561, 2632, 2703, 2774, 2845], // h=550
    [1461, 1534, 1606, 1678, 1751, 1823, 1895, 1968, 2040, 2112, 2185, 2257, 2329, 2402, 2474, 2546, 2619, 2691, 2764, 2836, 2908], // h=575
    [1496, 1570, 1644, 1717, 1791, 1865, 1939, 2012, 2086, 2160, 2234, 2307, 2381, 2455, 2529, 2593, 2676, 2750, 2824, 2898, 2971], // h=600
  ],
  // Kırmızı alan: H ≥ 525cm VE W ≥ 475cm
  isRedZone: (wCm, hCm) => hCm >= 525 && wCm >= 475,
};

// ─── SKY 1500 ──────────────────────────────────────────────────────────────
// Max: 6m × 6m, 25cm adım
// Garanti kapsamı dışı: H ≥ 550cm VE W ≥ 550cm
export const SKY1500 = {
  widths:  [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
  heights: [100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400, 425, 450, 475, 500, 525, 550, 575, 600],
  prices: [
    // w→  100   125   150   175   200   225   250   275   300   325   350   375   400   425   450   475   500   525   550   575   600
    [1007, 1059, 1112, 1164, 1217, 1270, 1322, 1375, 1427, 1480, 1532, 1585, 1638, 1690, 1743, 1795, 1848, 1901, 1953, 2006, 2058], // h=100
    [1038, 1092, 1146, 1200, 1254, 1308, 1362, 1416, 1470, 1524, 1578, 1632, 1686, 1740, 1794, 1848, 1902, 1956, 2010, 2064, 2118], // h=125
    [1070, 1125, 1181, 1236, 1291, 1347, 1402, 1458, 1513, 1569, 1624, 1679, 1735, 1790, 1846, 1901, 1957, 2012, 2067, 2123, 2178], // h=150
    [1101, 1158, 1215, 1272, 1329, 1385, 1442, 1499, 1556, 1613, 1670, 1727, 1783, 1840, 1897, 1954, 2011, 2068, 2124, 2179, 2235], // h=175
    [1133, 1191, 1249, 1307, 1366, 1424, 1482, 1541, 1599, 1657, 1715, 1774, 1832, 1890, 1949, 2007, 2065, 2123, 2179, 2235, 2298], // h=200
    [1164, 1224, 1284, 1343, 1403, 1463, 1522, 1582, 1642, 1701, 1761, 1821, 1881, 1940, 2000, 2060, 2119, 2179, 2239, 2298, 2358], // h=225
    [1196, 1257, 1318, 1379, 1440, 1501, 1562, 1624, 1685, 1746, 1807, 1868, 1929, 1990, 2051, 2112, 2174, 2235, 2296, 2357, 2418], // h=250
    [1227, 1290, 1352, 1415, 1477, 1540, 1602, 1665, 1728, 1790, 1853, 1915, 1978, 2040, 2103, 2165, 2228, 2290, 2353, 2415, 2478], // h=275
    [1259, 1323, 1387, 1451, 1515, 1579, 1642, 1706, 1770, 1834, 1898, 1962, 2026, 2090, 2154, 2218, 2282, 2346, 2410, 2474, 2538], // h=300
    [1290, 1356, 1421, 1486, 1552, 1617, 1683, 1748, 1813, 1879, 1944, 2009, 2075, 2140, 2206, 2271, 2336, 2402, 2467, 2533, 2598], // h=325
    [1322, 1389, 1455, 1522, 1589, 1656, 1723, 1789, 1856, 1923, 1990, 2057, 2123, 2190, 2257, 2324, 2391, 2457, 2524, 2591, 2658], // h=350
    [1353, 1421, 1490, 1558, 1626, 1694, 1763, 1831, 1899, 1967, 2036, 2104, 2172, 2240, 2308, 2377, 2445, 2513, 2581, 2650, 2718], // h=375
    [1385, 1454, 1524, 1594, 1663, 1733, 1803, 1872, 1942, 2012, 2081, 2151, 2221, 2290, 2360, 2429, 2499, 2569, 2638, 2708, 2778], // h=400
    [1416, 1487, 1558, 1629, 1701, 1772, 1843, 1914, 1985, 2056, 2127, 2198, 2269, 2340, 2411, 2482, 2553, 2624, 2696, 2767, 2838], // h=425
    [1448, 1520, 1593, 1665, 1738, 1810, 1883, 1955, 2028, 2100, 2173, 2245, 2318, 2390, 2463, 2535, 2608, 2680, 2753, 2825, 2898], // h=450
    [1479, 1553, 1627, 1701, 1775, 1849, 1923, 1997, 2071, 2145, 2218, 2292, 2366, 2440, 2514, 2588, 2662, 2736, 2810, 2884, 2958], // h=475
    [1511, 1586, 1661, 1737, 1812, 1887, 1963, 2038, 2113, 2189, 2264, 2339, 2415, 2490, 2566, 2641, 2716, 2792, 2867, 2942, 3018], // h=500
    [1542, 1619, 1696, 1773, 1849, 1926, 2003, 2080, 2156, 2233, 2310, 2387, 2463, 2540, 2617, 2694, 2772, 2847, 2924, 3001, 3077], // h=525
    [1574, 1652, 1730, 1808, 1887, 1965, 2043, 2121, 2199, 2277, 2356, 2434, 2512, 2590, 2668, 2747, 2825, 2903, 2981, 3059, 3137], // h=550 ← kırmızı başlangıcı
    [1605, 1685, 1765, 1844, 1924, 2003, 2083, 2163, 2242, 2322, 2401, 2481, 2561, 2640, 2720, 2799, 2879, 2959, 3038, 3118, 3197], // h=575
    [1637, 1718, 1799, 1880, 1961, 2042, 2123, 2204, 2285, 2366, 2447, 2528, 2609, 2690, 2771, 2852, 2933, 3014, 3095, 3176, 3257], // h=600
  ],
  // Kırmızı alan: H ≥ 550cm VE W ≥ 550cm
  isRedZone: (wCm, hCm) => hCm >= 550 && wCm >= 550,
};

// ─── MODEL HARITALAMASI ─────────────────────────────────────────────────────
const MODEL_MAP = {
  "Sky 1300": SKY1300,
  "Sky 1400": SKY1400,
  "Sky 1500": SKY1500,
};

// Sky matrisleri de matris ekranından (MongoDB) yönetilir; statik tablolar yedektir.
let DB_SKY_MATRICES = null;

/** /api/matrices listesinden Sky Zip matrislerini alıp aktif kaynak yapar. */
export function setSkyZipMatrices(list) {
  const map = {};
  (list || []).forEach((m) => {
    if (!m.skyModel || !m.fabricFamily || !m.prices?.length) return;
    const key = skyKey(m.skyModel);
    map[key] = map[key] || {};
    map[key][m.fabricFamily] = {
      widths: m.widths, heights: m.heights, prices: m.prices, noWarranty: m.noWarranty || [],
      name: m.name, id: m.id,
    };
  });
  DB_SKY_MATRICES = Object.keys(map).length ? map : null;
  return DB_SKY_MATRICES;
}

/** "Art 1400" / "Sky 1400" / "1400" → "Sky 1400" - normalizasyon yardımcısı */
function skyKey(model) {
  const n = String(model || "").replace(/\D/g, "");
  return n ? `Sky ${n}` : "";
}

/**
 * Sky Zip'te kumaş aileleri: helio · akrilik (Soltis 96) · serge.
 * Dikey Zip'ten farklı: Akrilik'in KENDİ matrisi var.
 */
export function resolveSkyFabricFamily(fabricBrand) {
  const b = (fabricBrand || "").toLowerCase();
  if (!b) return null;
  if (b.includes("serge")) return "serge";
  if (b.includes("akrilik") || b.includes("soltis")) return "akrilik";
  if (b.includes("helio") || b.includes("copaco")) return "helio";
  return null;
}

/**
 * Sky Zip fiyatı — önce matris ekranındaki (DB) kumaş bazlı matris, yoksa statik yedek tablo.
 * @param {string} model        "Art 1300" | "Sky 1400" | ...
 * @param {string} fabricBrand  Kumaş çeşidi (Helioscreen / Akrilik / Serge Ferrari ...)
 */
export function lookupSkyZipPrice(model, fabricBrand, wCm, hCm) {
  const key = skyKey(model);
  const family = resolveSkyFabricFamily(fabricBrand);
  const dbM = family ? DB_SKY_MATRICES?.[key]?.[family] : null;
  if (dbM) {
    return {
      ...interpolate(dbM, wCm, hCm), noMatrix: false, family, model: key, wCm, hCm,
      source: "db", matrixName: dbM.name, matrixId: dbM.id,
    };
  }
  const fb = MODEL_MAP[key];
  if (!fb) return { price: null, isRedZone: false, outOfRange: false, noMatrix: true, family, model: key };
  const r = interpolate(fb, wCm, hCm);
  return {
    ...r, isRedZone: r.outOfRange ? false : fb.isRedZone(wCm, hCm),
    noMatrix: false, family, model: key, wCm, hCm,
    source: "static", matrixName: `${key} Zip Perde (yedek tablo)`, matrixId: null,
  };
}

// ─── DİKEY ZIP (Art 90/110/130/140) — KUMAŞ BAZLI MATRİS ────────────────────
// Artbey listesinde her Art modeli için 3 ayrı matris var:
//   helio      → Helio Screen kumaş  (Akrilik kumaş da bu matristen fiyatlanır)
//   serge      → Serge Ferrari kumaş (86 / 92 / 96 serilerinin tümü)
//   transparan → Transparan (şeffaf) kumaş — sadece Dikey Zip'te
export const TRANSPARAN_FABRIC = "Transparan Kumaş";

// Matris ekranından (MongoDB) gelen canlı veriler; yoksa PDF'ten üretilen statik dosya kullanılır.
let DB_ART_MATRICES = null;

/** /api/matrices listesinden Dikey Zip matrislerini alıp aktif kaynak yapar. */
export function setArtZipMatrices(list) {
  const map = {};
  (list || []).forEach((m) => {
    if (!m.artModel || !m.fabricFamily || !m.prices?.length) return;
    map[m.artModel] = map[m.artModel] || {};
    map[m.artModel][m.fabricFamily] = {
      widths: m.widths, heights: m.heights, prices: m.prices, noWarranty: m.noWarranty || [],
      name: m.name, id: m.id,
    };
  });
  DB_ART_MATRICES = Object.keys(map).length ? map : null;
  return DB_ART_MATRICES;
}

export function resolveArtFabricFamily(fabricBrand) {
  const b = (fabricBrand || "").toLowerCase();
  if (!b) return null;
  if (b.includes("transparan") || b.includes("şeffaf") || b.includes("seffaf")) return "transparan";
  if (b.includes("serge")) return "serge";
  if (b.includes("helio") || b.includes("copaco") || b.includes("akrilik")) return "helio";
  return null;
}

// Zip matris fiyatı: matriste tanımlı adım aralığına göre (Art130: 50cm, diğerleri: 25cm)
// GİRİLEN ÖLÇÜ YUKARI YUVARLANIR ve o hücrenin fiyatı DOĞRUDAN kullanılır (Sineklik matrisleriyle
// aynı mantık) — ARADEĞER (bilineer interpolasyon) HESAPLANMAZ. Fiyat, adım aralığı içinde sabittir
// ve sadece bir üst basamağa geçildiğinde değişir.
function interpolate(m, wCm, hCm) {
  const maxW = m.widths[m.widths.length - 1];
  const maxH = m.heights[m.heights.length - 1];
  if (wCm > maxW || hCm > maxH || wCm < m.widths[0] || hCm < m.heights[0]) {
    return { price: null, isRedZone: false, outOfRange: true };
  }
  let wi = m.widths.findIndex(v => v >= wCm);
  if (wi < 0) wi = m.widths.length - 1;
  let hi = m.heights.findIndex(v => v >= hCm);
  if (hi < 0) hi = m.heights.length - 1;

  const price = m.prices[hi][wi];
  const nw = m.noWarranty || [];
  const isRedZone = Boolean(nw[hi]?.[wi]);
  const trace = { w: m.widths[wi], h: m.heights[hi], cellPrice: price };
  const iskontoOrani = Number(m.iskontoOrani) || 0;
  const costPrice = iskontoOrani > 0 ? price * (1 - iskontoOrani / 100) : price;
  return { price, isRedZone, outOfRange: false, trace, iskontoOrani, costPrice };
}

/**
 * Dikey Zip (Art) fiyatı: model + kumaş ailesi matrisinden bilineer interpolasyon.
 * @returns {{price:number|null, isRedZone:boolean, outOfRange:boolean, noMatrix:boolean}}
 */
export function lookupArtZipPrice(model, fabricBrand, wCm, hCm) {
  const family = resolveArtFabricFamily(fabricBrand);
  const dbM = family ? DB_ART_MATRICES?.[model]?.[family] : null;
  const m = dbM || (family ? ARTBEY_MATRICES[model]?.[family] : null);
  if (!m) return { price: null, isRedZone: false, outOfRange: false, noMatrix: true, family };
  return {
    ...interpolate(m, wCm, hCm), noMatrix: false, family, model, wCm, hCm,
    source: dbM ? "db" : "static",
    matrixName: dbM?.name || `${model} Zip — ${family}`,
    matrixId: dbM?.id || null,
  };
}

// ─── KUMANDA FİYATLARI ──────────────────────────────────────────────────────// Tüm modellerine uygulanır (Art 90/110/130/140 + Sky 1300/1400/1500)
export const REMOTE_PRICES = {
  Somfy: [
    { label: "Somfy 1 Kanal",  price: 41 },
    { label: "Somfy 4 Kanal",  price: 71 },
    { label: "Somfy 16 Kanal", price: 195 },
  ],
  Becker: [
    { label: "Becker 1 Kanal",  price: 48 },
    { label: "Becker 5 Kanal",  price: 70 },
    { label: "Becker 10 Kanal", price: 136 },
  ],
  Nice: [
    { label: "Nice 1 Kanal",  price: 50 },
    { label: "Nice 6 Kanal",  price: 58 },
    { label: "Nice 18 Kanal", price: 91 },
  ],
  Mosel: [
    { label: "Mosel 1 Kanal",  price: 15 },
    { label: "Mosel 6 Kanal",  price: 25 },
    { label: "Mosel 15 Kanal", price: 35 },
  ],
};

// Logo baskı opsiyonu
export const LOGO_PRINT_PRICE = 48; // EUR
